module.exports = __webpack_public_path__ + "static/media/lumos-trailor-compressed.b086800e.mp4";